import {memo} from 'react';

import Stack from '@mui/material/Stack';

import NavList from './nav-list';
import {NavProps, NavGroupProps} from '../types';
import SubModuleNavList from './submodule-nav-list';

// ----------------------------------------------------------------------

function NavSectionMini({data, slotProps, ...other}: NavProps) {
  return (
    <Stack
      component="nav"
      id="nav-section-mini"
      spacing={`${slotProps?.gap || 4}px`}
      {...other}>
      {data?.map((group, index) => (
        <Group
          key={group.subheader || index}
          moduleName={group.moduleName}
          items={group.items ?? []}
          slotProps={slotProps}
        />
      ))}
    </Stack>
  );
}

export default memo(NavSectionMini);

// ----------------------------------------------------------------------

function Group({moduleName, items, slotProps}: NavGroupProps) {
  const renderContent = items.map(list => {
    if (moduleName) {
      return (
        <SubModuleNavList
          key={list.name}
          data={list}
          depth={1}
          slotProps={slotProps}
          moduleName={moduleName}
        />
      );
    } else {
      return (
        <NavList
          key={list.name}
          data={list}
          depth={1}
          slotProps={slotProps}
          moduleName={moduleName}
        />
      );
    }
  });

  return renderContent;
}
